
import { createContext, useContext, useState} from 'react';



const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(sessionStorage.getItem('user') || null);

    const login = (accessToken) => {
        setUser(accessToken); // Store the access token or user info
    };

    const logout = () => {
        setUser(null);
        sessionStorage.removeItem('user');
        
    };



    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};